import { useRoutes } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import { routesConfig } from "./config/routesConfig";

const AppRouter = () => {
  const dynamicRoutes = useRoutes(routesConfig);
  return <ErrorBoundary>{dynamicRoutes}</ErrorBoundary>;
};

export default AppRouter;
